import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { continuePathQueryParam } from '../../constants';
import { AuthNavigatorService } from '../auth-navigator/auth-navigator.service';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class AuthGuardService  {
  constructor(private authService: AuthService, private router: Router, private authNavigator: AuthNavigatorService) {}

  async canActivate(_, state: RouterStateSnapshot): Promise<boolean> {
    // startsWith solves the bug with calling wrong authguard
    if (!this.router.routerState.snapshot.url.startsWith('/auth') && !(await this.authService.isAuthenticatedAsync())) {
      this.authNavigator.redirectToSignIn({
        [continuePathQueryParam]: state.url
      });

      return false;
    }

    return true;
  }
}
